import { render, staticRenderFns } from "./CardPacote.vue?vue&type=template&id=ca6ad792&scoped=true"
import script from "./CardPacote.vue?vue&type=script&lang=js"
export * from "./CardPacote.vue?vue&type=script&lang=js"
import style0 from "./CardPacote.vue?vue&type=style&index=0&id=ca6ad792&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6ad792",
  null
  
)

export default component.exports